import React from 'react';
import { StyledCardHeader, StyledCardHeaderTypography } from './styled';
export const CardHeader = ({ component, children, ...props }) => (React.createElement(StyledCardHeader, { ...props },
    React.createElement(StyledCardHeaderTypography, { as: component }, children)));
